<template>
  <!-- MODAL VER SOLICITUD -->
  <div
    class="modal fade modal-confirmar"
    id="ver-detalle-historial"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="
        modal-dialog modal-dialog-centered modal-lg
        modal-confirmar__dialog justify-content-center
      "
    >
      <div class="modal-content modal-confirmar__content">
        <div class="modal-header modal-confirmar__header">
          <button
            type="button"
            class="btn-close modal-confirmar__btn-cerrar"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body modal-confirmar__body">
          <div class="container modal-confirmar__container">
            <div class="row modal-confirmar__row">
              <div class="col-12 modal-confirmar__col text-start">
                <h3 class="modal-confirmar__h3" :style="{ color: colorPrimario }">Detalles de la solicitud</h3>
              </div>
              <div class="col-lg-6 col-md-6 col-12 modal-confirmar__col">
                <div class="row modal-confirmar__row">
                  <div class="modal-confirmar__col text-start">
                    <p class="modal-confirmar__titulo mb-0">
                      Resumen solicitud
                    </p>
                    <hr class="modal-confirmar__hr" />
                  </div>
                </div>
                <div class="row modal-confirmar__row justify-content-start">
                  <p class="modal-confirmar__subtitulo mb-1 text-start">
                    Categoría
                  </p>
                  <div class="modal-confirmar__col-bordes text-start py-1">
                    <p
                      class="
                        modal-confirmar__texto modal-confirmar__texto--18px
                        mb-0
                      "
                    >
                      Aseo - Aquí van los detalles de aseo
                    </p>
                  </div>
                </div>
                <div class="row modal-confirmar__row mt-3">
                  <div class="modal-confirmar__col text-start">
                    <p class="modal-confirmar__titulo mb-0">
                      Problema reportado
                    </p>
                    <hr class="modal-confirmar__hr mb-1" />
                  </div>
                </div>
                <div
                  class="row modal-confirmar__row justify-content-start"
                  v-if="solicitud.detalles.length > 0"
                >
                  <div
                    class="modal-confirmar__col text-start py-1"
                    v-for="detalle in solicitud.detalles"
                    :key="detalle.id_detalle"
                  >
                    <p class="modal-confirmar__texto mb-0">
                      <img
                        src="@/assets/img/intranet/hoteleria-solicitudes/icono-check-gris.png"
                        class="modal-confirmar__icono-check"
                        alt="Check de problema"
                      />
                      {{ detalle.detalle.nombre_detalle }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12 modal-confirmar__col">
                <img
                  :src="solicitud.documentos[0].url_documento"
                  class="modal-confirmar__img-confirmacion mx-auto"
                  alt="Ícono de valor"
                />
              </div>
              <div class="col-12 col-md-12 col-12 modal-confirmar__col mt-3">
                <div class="row modal-confirmar__row">
                  <div class="modal-confirmar__col text-start">
                    <p class="modal-confirmar__titulo mb-0">
                      Detalle solicitud
                    </p>
                  </div>
                </div>
                <div class="row modal-confirmar__row justify-content-start">
                  <div class="modal-confirmar__col-bordes text-start pt-1 pb-3">
                    <p
                      class="
                        modal-confirmar__texto modal-confirmar__texto--18px
                        mb-0
                      "
                    >
                      {{ solicitud.descripcion_solicitud }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-confirmar__footer"></div>
      </div>
    </div>
  </div>
  <!-- MODAL VER SOLICITUD -->
</template>

<script>
export default {
  name: "ModalVerSolicitudHistorial",
  data() {
    return {
      solicitud: {
        id_solicitud: "",
        codigo_solicitud: "",
        fecha_creacion: "",
        descripcion_solicitud: "",
        documentos: [
          {
            id_documento: "",
            url_documento: "",
          },
        ],
        detalles: [],
        estado: {
          id_estado: "",
          nombre_estado: "",
          color: "",
        },
      },
    };
  },
  mounted() {
    this.$root.$on("abrir-modal-detalle-historial", (solicitud) => {
      this.solicitud = solicitud;
    });
  },
};
</script>